import { apiClient } from './api';
import { ENDPOINTS } from './constants';

export const shipmentService = {
  getShipments: async (status = null, limit = 50, offset = 0) => {
    try {
      const params = { limit, offset };
      if (status) params.status = status;

      const response = await apiClient.get(ENDPOINTS.SHIPMENTS.LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Fetch every shipment page until the API reports no more results. */
  fetchAllShipments: async (status = null) => {
    const PAGE_SIZE = 50;
    let offset = 0;
    let allShipments = [];
    let total = null;

    while (true) {
      const response = await shipmentService.getShipments(status, PAGE_SIZE, offset);
      const batch = response?.data?.shipments ?? [];
      if (response?.data?.total != null) {
        total = response.data.total;
      }

      allShipments = allShipments.concat(batch);
      console.info(
        `[Dockie] fetchAllShipments page offset=${offset} batch=${batch.length} loaded=${allShipments.length} total=${total ?? "unknown"}`,
      );

      if (!batch.length) break;
      if (batch.length < PAGE_SIZE) break;
      if (total != null && allShipments.length >= total) break;

      offset += batch.length;
    }

    return { shipments: allShipments, total: total ?? allShipments.length };
  },

  getShipmentByChat: async (chatId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.SHIPMENTS.BY_CHAT}/${chatId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getShipmentById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.SHIPMENTS.BY_ID}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
